/**
* Personal Intro JS
* -----------------------------------------------------------------------------
*
* All the JS for the Personal Intro component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'personal-intro',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.personal-intro' ).each( function( key, val ) {
        const images = $( this ).find( '.personal-intro__images' )[0];
        const imagesHeight = $( images ).outerHeight();
        const imagesVisibleWidth = $( images ).outerWidth();
        const imagesWidth = $( images )[0].scrollWidth;

        const mobileImages = $( this ).find( '.personal-intro__images--mobile' )[0];
        const mobileImagesHeight = $( mobileImages ).outerHeight();
        const mobileImagesVisibleWidth = $( mobileImages ).outerWidth();
        const mobileImagesWidth = $( mobileImages )[0].scrollWidth;

        let endPoint = imagesWidth;

        if ( window.innerWidth < 1024 ) {
          endPoint = mobileImagesWidth;
        }

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top bottom',
            end: endPoint + ' top',
            scrub: 1,
          },
        } );

        tl.to( images, {x: '-' + ( ( imagesWidth - imagesVisibleWidth ) * 1.5 ), ease: 'linear'}, 0 );
        tl.to( mobileImages, {x: '-' + ( mobileImagesWidth - mobileImagesVisibleWidth ), ease: 'linear'}, 0 );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'personal-intro', COMPONENT );
} )( app );
